document.addEventListener('DOMContentLoaded', () => {
  const fundLengthBlock = document.querySelector('.js-pifFundLength')
  if (fundLengthBlock) {
    const aboutInfoSpan = fundLengthBlock.querySelector('.about-info')
    if (aboutInfoSpan && aboutInfoSpan.textContent.trim() === '0') {
      fundLengthBlock.style.display = 'none'
    }
  }

  const portfolioParamsBlock = document.querySelector('.js-portfolioParams')
  if (portfolioParamsBlock) {
    const accordionContent = portfolioParamsBlock.querySelectorAll('.accordion__content')
    const aboutInfo = accordionContent[0].querySelector('.about-info')
    if (aboutInfo && aboutInfo.textContent.trim() === '0' && accordionContent.length === 1) {
      portfolioParamsBlock.style.display = 'none'
    }
  }
})